module.exports = "https://web-assets.ifttt.com/packs/media/location_field/mask-721f321d.svg";